<template>
  <div>
    <el-row>
      <el-col :span="18">
        <el-row :gutter="4">
          <el-col :span="5">
            <el-input
              size="small"
              clearable
              v-model="searchName"
              placeholder="请输入员工姓名/岗位名称/部门名称"
            ></el-input>
          </el-col>
          <el-col :span="1">
            <el-button
              icon="el-icon-search"
              size="small"
              @click="SearchByName"
            ></el-button>
          </el-col>
          <el-col :span="3">
            <el-button type="primary" size="small" @click="Refresh" plain
              >刷新</el-button
            >
          </el-col>
          <!--currentChargeDept  -->
          <el-col
            :span="11"
            v-if="chargeDepts.length > 0 || currentChargeDept"
            style="font-size: 14px"
          >
            <el-select
              size="small"
              :disabled="disabled"
              @change="handleDeptTypeChage"
              v-model="currentChargeDept"
              placeholder="请选择当前操作部门"
            >
              <el-option
                v-for="item in chargeDepts"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-tag style="margin-left: 6px"
              >当前操作部门：{{ deptName }}</el-tag
            >
            <!-- {{'('+deptName+')'}} -->
          </el-col>
          <el-col :span="1">
            <el-button
              icon="el-icon-plus"
              v-if="currentRole.Key != 'admin' && currentRole.Key != 'CEO'"
              @click="AddKPI"
              size="small"
            ></el-button>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="6">
        <el-row>
          <el-col style="float: right">
            <el-button
              v-if="isShowTijiao"
              :disabled="isDisabled"
              type="primary"
              @click="AddMonth('0')"
              size="small"
              plain
              >提交</el-button
            >
            <el-button type="warning" @click="copyKPI('0')" size="small" plain
              >复制上月KPI</el-button
            >
            <el-button type="warning" @click="copyKPI('1')" size="small" plain
              >复制上季KPI</el-button
            >
          </el-col>
          <!-- <el-col :span="10">
            <el-button type="warning" @click="copyKPI('0')" size="small" plain>复制上月KPI</el-button>
          </el-col>
          <el-col :span="10">
            <el-button type="warning" @click="copyKPI('1')" size="small" plain>复制上季KPI</el-button>
          </el-col> -->
        </el-row>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="24">
        <el-table
          border
          :data="SettingList"
          style="width: 100%"
          v-loading="loading"
          size="small"
        >
          <el-table-column
            min-width="10"
            prop="ItemType"
            :formatter="ItemTypeFomartter"
            label="类型"
          ></el-table-column>
          <el-table-column
            min-width="10"
            prop="KeyName"
            label="名称"
          ></el-table-column>
          <el-table-column
            min-width="10"
            prop="PeriodType"
            :formatter="PeriodTypeFormatter"
            label="周期类型"
          ></el-table-column>
          <el-table-column
            min-width="10"
            prop="Period"
            label="周期"
          ></el-table-column>
          <el-table-column
            min-width="10"
            prop="TrueName"
            label="操作人"
          ></el-table-column>
          <el-table-column
            min-width="10"
            prop="CreateTime"
            label="添加时间"
          ></el-table-column>
          <el-table-column min-width="10" label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="viewKPI(scope.row)" size="small"
                >详情</el-button
              >
              <!-- @click="viewKPI(scope.row)" -->
              <el-button
                type="text"
                @click="viewKPIResult(scope.row)"
                size="small"
                >查看结果</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row style="text-align: right">
      <el-col>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="pageSizes"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
          style="float: right"
        ></el-pagination>
      </el-col>
    </el-row>
    <el-dialog
      width="70%"
      :title="dialagTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <div class="viewKPITitle">
        <el-row>
          <el-col :span="6">
            <span
              >类型：{{ ItemTypeFomartterDialog(viewKPITitle.ItemType) }}</span
            >
          </el-col>
          <el-col :span="6">
            <span>名称：{{ viewKPITitle.KeyName }}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <!-- PeriodTypeFoormatter(viewKPITitle.PeriodType) -->
            <span
              >周期类型：{{
                viewKPITitle.PeriodType == 1 ? "季度" : "月"
              }}</span
            >
          </el-col>
          <el-col :span="6">
            <span
              >周期：{{ viewKPITitle.Period
              }}{{ viewKPITitle.PeriodType == 1 ? "季度" : "月" }}</span
            >
          </el-col>
        </el-row>
      </div>
      <el-divider></el-divider>
      <el-table
        :data="KPIItems"
        show-summary
        style="width: 100%"
        v-loading="loading"
        size="small"
      >
        <el-table-column
          min-width="100"
          prop="KPIType"
          :formatter="KPITypeFomartter"
          label="KPI类型"
        ></el-table-column>
        <el-table-column
          min-width="100"
          prop="KPI"
          label="KPI名称"
        ></el-table-column>
        <el-table-column
          min-width="50"
          prop="KPIWeight"
          label="KPI权重"
        ></el-table-column>
        <el-table-column
          min-width="200"
          prop="Explain"
          label="指标说明"
        ></el-table-column>
        <el-table-column
          min-width="250"
          prop="Contents"
          label="考核细则"
        ></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="EditKPI">编辑</el-button>
      </span>
    </el-dialog>

    <EditKPIItem
      ref="detailDialog"
      :_singleData="singleData"
      :_list="KPIItems"
      :_currentDeptId="frameid"
      :_isAdd="isAdd"
      :_itemType="itemType"
      :_dialogVisible.sync="dialogVisible"
      :_dialogEditVisible.sync="dialogEditVisible"
      :_editDialogTitle="editDialogTitle"
    ></EditKPIItem>
  </div>
</template>
<script>
import { Decrypt, Encrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";
import {
  GetKPISettingList,
  ViewKPIDetail,
  GetChargeDeptsByUserCode,
  AddKPI,
} from "../../until/ZeusApiSDK/Logic/KPILogic";
import { GetCurrentUserInfo } from "../../until/ZeusApiSDK/Logic/HomeLogic";
import EditKPIItem from "../KPI/EditKPIItem";
export default {
  props: {
    pt: {
      Type: Number,
    },
  },
  provide: function () {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      searchName: "",
      SettingList: [],
      KPIItems: [],
      pageSizes: [10, 20, 50, 100, 200],
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      loading: true,
      viewKPITitle: {},
      dialogVisible: false,
      dialogEditVisible: false,
      dialagTitle: "设置详情",
      pType: this.pt,
      currentChargeDept: {},
      chargeDepts: [],
      disabled: true,
      isShowTijiao: false,
      editDialogTitle: "添加KPI",
      isAdd: true,
      currentRole: {}, //获取当前用户角色
      currentUser: {}, //当前登录用户信息
      deptName: "", //当前操作部门
      itemType: 0, //当前选择
      frameid: "", //当前部门id
      isDisabled: false,
      singleData: {},
      // currentChargeDept:"",
      // isRouterAlive:true,//最新添加
    };
  },
  created() {
    //获取当前用户角色
    this.getCurrentRole();
    //获取当前登录信息
    this.getCurrentUserInfo();

    //获取部门方法中第一次加载列表数据
    this.GetChargeDepts();
    if (this.currentRole.Key == "Manager") {
      this.isShowTijiao = true;
    }
  },
  methods: {
    //获取当前用户角色
    getCurrentRole: function () {
      var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
      this.currentRole = JSON.parse(Decrypt(currentUserRole));
      if (
        this.currentRole.Key == "admin" ||
        this.currentRole.Key == "director" ||
        this.currentRole.Key == "Manager"
      ) {
        this.disabled = false;
      }
    },
    getCurrentUserInfo: function () {
      // var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
      // this.currentRole = JSON.parse(Decrypt(currentUserRole));
      // if( this.currentRole.Key=='admin'||this.currentRole.Key=='director'||this.currentRole.Key=='Manager'){
      //   this.disabled=false;
      // }
      var userinfo = window.sessionStorage.getItem("userinfo");
      userinfo = JSON.parse(Decrypt(userinfo));
      this.currentUser = userinfo;
    },
    //最新添加
    // reload:function(){
    //   this.isRouterAlive=false;
    //   this.$nextTick(function(){
    //     this.isRouterAlive=true;
    //   });
    // },
    // getCurrentFrameID: function() {
    //   var frameArray= this.GetChargeDepts();
    //   // var frameid;
    //   // if (this.chargeDepts.length > 0) {
    //   //   if (this.currentChargeDept.value != "无") {
    //   //     frameid = this.currentChargeDept.value;
    //   //   } else {
    //   //     frameid = this.chargeDepts[0].value;
    //   //   }
    //   // } else {
    //   //   frameid = this.currentUser.FrameId;
    //   // }
    //   return frameid;
    // },

    handleSizeChange(val) {
      this.pageSize = val;
      this.GetSettingKPIPageList(this.frameid);
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetSettingKPIPageList(this.frameid);
    },
    SearchByName: function () {
      this.pageIndex = 1;
      this.GetSettingKPIPageList(this.frameid);
    },
    Refresh: function () {
      this.GetSettingKPIPageList(this.frameid);
    },
    GetSettingKPIPageList: function (frameid) {
      this.loading = true;
      // var userinfo = GetCurrentUserInfo();
      GetKPISettingList(
        this.currentUser.UserCode,
        this.currentRole.Key,
        frameid,
        this.pType,
        this.pageIndex,
        this.pageSize,
        this.searchName
      ).then((pageRes) => {
        this.SettingList = pageRes.List; //.filter(p => p.PeriodType == this.pType);
        this.totalCount = pageRes.TotalCount;
        this.loading = false;
      });
    },
    viewKPI: function (row) {
      this.singleData = row;
      this.dialogVisible = true;
      ViewKPIDetail(row.Id).then((res) => {
        this.KPIItems = res;
        this.KPIItems.forEach((element) => {
          element.Contents = element.Contents.replace(/\ +/g, "").replace(/[\n]/g,"");
        });
        this.viewKPITitle = res[0];
      });
    },
    //查看KPI结果
    viewKPIResult: function (row) {
      this.$router.push("/KPI/KPIResult?id=" + row.Id);
    },
    GetChargeDepts: function () {
      var deptModelStory = window.sessionStorage.getItem("deptModel");
      var that = this;
      GetChargeDeptsByUserCode(this.currentUser.UserCode).then((res) => {
        if (res) {
          if (res.list.length > 0) {
            that.disabled = false;
            res.list.forEach((element) => {
              that.chargeDepts.push({
                value: element.Id,
                label: element.ClassName,
              });
            });

            var dept = {
              value: that.chargeDepts[0].value,
              label: that.chargeDepts[0].label,
            };
            that.currentChargeDept = dept;
          } else {
            that.chargeDepts.push({
              value: "无",
              label: "无",
            });
            var dept = {
              value: "无",
              label: "无",
            };
            that.currentChargeDept = dept;
          }

          //将部门保存到全局中
          this.frameid = that.currentChargeDept.value;
          if (!deptModelStory) {
            //将加密后的操作部门保存到session中
            window.sessionStorage.setItem(
              "deptModel",
              Encrypt(JSON.stringify(that.currentChargeDept))
            );

            var deptModelStory = window.sessionStorage.getItem("deptModel");
            if (deptModelStory) {
              that.deptName = JSON.parse(Decrypt(deptModelStory)).label;
            } else {
              if (!that.currentChargeDept) {
                this.frameid = "";
                that.deptName = "无";
                that.currentChargeDept = {
                  value: "无",
                  label: "无",
                };
              } else {
                this.frameid = that.currentChargeDept.value;
                that.deptName = that.currentChargeDept.label;
              }
            }

            //第一次加载首列表数据
            this.GetSettingKPIPageList(this.frameid);
          }
        }
      });
      if (!deptModelStory) {
        this.currentChargeDept = JSON.parse(Decrypt(deptModelStory));

        //第一次加载首列表数据
        this.GetSettingKPIPageList(this.currentChargeDept.value);
      }
    },
    EditKPI: function () {
      this.isAdd = false;
      this.editDialogTitle = "编辑KPI";
      this.dialogVisible = false;
      this.dialogEditVisible = true;
      // this.KPIItems=this.KPIItems;
      // this.viewKPITitle.ItemType=this.itemType;
      // this.$refs.detailDialog.loadDialogData(this.itemType);
    },
    //提交月度KPI
    AddMonth: function (periodType) {
      this.isDisabled = true;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)",
      });
      AddKPI(
        periodType,
        this.currentUser.UserId,
        this.currentUser.UserCode,
        this.currentUser.TrueName
      ).then((res) => {
        loading.close();
        if (res.Result == "200") {
          //获取部门方法中第一次加载列表数据
          this.GetChargeDepts();
          this.GetSettingKPIPageList(this.frameid);
        } else {
          this.$message.error(res.Message);
        }
      });
    },
    AddKPI: function () {
      this.isAdd = true;
      this.editDialogTitle = "添加KPI";
      this.KPIItems = [];
      this.dialogEditVisible = true;
      //由于接口延迟需重新为当前部门赋值
      // this._currentDeptId = this.currentChargeDept;
      // this.$refs.detailDialog.loadDialogData(this._currentDeptId);

      // this.$refs.detailDialog.loadDialogData(this.itemType);
      // this.$refs.refDialog.loadDialogData(this._currentDeptId);
    },
    ItemTypeFomartter(row, column, cellValue, index) {
      this.itemType = cellValue;
      if (cellValue == 0) {
        return "部门";
      } else if (cellValue == 1) {
        return "岗位";
      } else {
        return "个人";
      }
    },
    //弹框显示当前类型
    ItemTypeFomartterDialog: function (cellValue) {
      this.itemType = cellValue;
      if (cellValue == 0) {
        return "部门";
      } else if (cellValue == 1) {
        return "岗位";
      } else {
        return "个人";
      }
    },
    PeriodTypeFormatter(row, column, cellValue, index) {
      if (cellValue == 1) {
        return "季度";
      } else {
        return "月度";
      }
    },
    KPITypeFomartter(row, column, cellValue, index) {
      if (cellValue == 0) {
        return "职能指标";
      } else if (cellValue == 1) {
        return "业绩指标";
      } else if (cellValue == 3) {
        return "自定义";
      } else if (cellValue == 4) {
        return "内部管理指标";
      } else if (cellValue == 5) {
        return "客户指标";
      } else if (cellValue == 6) {
        return "敬业度";
      } else if (cellValue == 7) {
        return "重点项目";
      } else if (cellValue == 8) {
        return "团队管理";
      } else {
        return "其他";
      }
    },
    //根据选择保存当前部门
    handleDeptTypeChage: function (deptId) {
      var deptName = "";
      this.chargeDepts.forEach((item) => {
        if (item.value == deptId) {
          deptName = item.label;
        }
      });
      var deptModel = {
        value: deptId,
        label: deptName,
      };
      this.deptName = deptName;
      //将加密后的操作部门保存到session中
      window.sessionStorage.setItem(
        "deptModel",
        Encrypt(JSON.stringify(deptModel))
      );
      this.frameid = this.currentChargeDept;
      this.currentChargeDept = deptModel;
      this.GetSettingKPIPageList(this.currentChargeDept.value);
    },
    //复制百科跳转到百科列表页
    copyKPI: function (val) {
      //val 0月度 1季度
      this.$router.push({ path: "/KPI/PrevKPIitem?periodType=" + val });
    },
  },
  watch: {
    pt: {
      handler(n, o) {
        //n为新值,o为旧值;
        this.pType = n;
        this.GetSettingKPIPageList();
      },
      deep: true,
    },
  },
  components: {
    EditKPIItem,
  },
};
</script>
<style lang="less" scoped>
.viewKPITitle {
  text-align: left;
  font-size: 14px;
  color: #72767b;
}
</style>